import { Provider } from '@angular/core';
import { FirebaseApp, FirebaseOptions, initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getMessaging } from 'firebase/messaging';
import {
  FIREBASE_APP,
  FIREBASE_AUTH,
  FIREBASE_FIRESTORE,
  FIREBASE_MESSAGING,
} from './firebase.tokens';

/**
 * Provides Firebase App/Auth/Firestore/Messaging using the plain `firebase`
 * SDK instead of @angular/fire, which currently has no release compatible
 * with this project's Angular version.
 */
export function provideFirebaseDirect(config: FirebaseOptions): Provider[] {
  return [
    {
      provide: FIREBASE_APP,
      useFactory: () => initializeApp(config),
    },
    {
      provide: FIREBASE_AUTH,
      useFactory: (app: FirebaseApp) => getAuth(app),
      deps: [FIREBASE_APP],
    },
    {
      provide: FIREBASE_FIRESTORE,
      useFactory: (app: FirebaseApp) => getFirestore(app),
      deps: [FIREBASE_APP],
    },
    {
      provide: FIREBASE_MESSAGING,
      useFactory: (app: FirebaseApp) => getMessaging(app),
      deps: [FIREBASE_APP],
    },
  ];
}
